<script setup lang="ts">
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import SideBar from './components/SideBar.vue'
import Header from './components/Header.vue'
import Main from './components/Main.vue'
import TagsView from './components/TagsView.vue'

const isCollapse = ref(false)
provide('isCollapse', {
  isCollapse,
  toggleCollapse: () => {
    isCollapse.value = !isCollapse.value
  },
})
</script>
<template>
  <el-config-provider :locale="zhCn">
    <div class="common-layout w-full h-full">
      <el-container>
        <SideBar />
        <el-container class="flex !flex-col w-full h-screen pr-[20px]">
          <div class="w-full"><Header /></div>
          <div class="w-full">
            <TagsView />
          </div>
          <div class="w-full"><Main /></div>
        </el-container>
      </el-container>
    </div>
  </el-config-provider>
</template>

<style scoped lang="scss">
.main-container {
  height: calc(100vh - 94px); // 60px header + 34px tags-view
}

/* 页面切换动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
